import { NavLink } from 'react-router-dom';
import Icon from '../primitives/Icon.jsx';

/**
 * One destination in the sidebar. The current route is marked for screen readers
 * (aria-current) and drawn as selected. `count` shows a small number, such as items waiting.
 */
const SidebarNavItem = ({ to, icon, label, count, end = false }) => {
  return (
    <NavLink to={to} end={end} className="comp-sidebar-nav-item">
      {icon && <Icon icon={icon} />}
      <span className="comp-sidebar-nav-item__label">{label}</span>
      {count > 0 && <span className="comp-sidebar-nav-item__count">{count}</span>}
    </NavLink>
  );
};

export default SidebarNavItem;
